export default "__VITE_ASSET__0764a825__"